import { RespostaNotasFiscais } from "app/types/pesquisa-orcamento/consultas/NotasFiscais";
import { DadosEntrega } from "app/types/pesquisa-orcamento/sub-consultas-notas-fiscais/Entrega";
import { RespostaNotasFiscaisItens } from "app/types/pesquisa-orcamento/sub-consultas-notas-fiscais/Itens";
import { BaseApi } from "./BaseApi";
import { LoteOrcamento } from "app/types/pesquisa-orcamento/consultas/Lotes";


export class NotaFiscalSaidaApi extends BaseApi {

    async ListarNotasFiscais(numeroOrcamento: number): Promise<RespostaNotasFiscais> {
        const resposta = await this.api.post(`/NotaFiscalSaida/NotasFiscais`, {
            numeroOrcamento
        })

        return resposta?.data
    }

    async ObterImagemCanhotoNotaFiscal(numord: number): Promise<Blob> {
        const resposta = await this.api.get(`/NotaFiscalSaida/ObterImagemCanhotoNotaFiscal`, {
            responseType: 'blob',
            params: {
                numord
            }
          })

        return resposta?.data
    }

    async Itens(codigoNotaFiscal: number): Promise<RespostaNotasFiscaisItens[]> {
        const resposta = await this.api.post(`/NotaFiscalSaida/Itens`, {
            codigoNotaFiscal
        })

        return resposta?.data
    }

    async Lotes(codigoNotaFiscal: number): Promise<LoteOrcamento[]> {
        const resposta = await this.api.post(`/NotaFiscalSaida/Lotes`, {
            codigoNotaFiscal
        })

        return resposta?.data
    }

    async Entrega(codigoNotaFiscal: number): Promise<Partial<DadosEntrega>> {
        const resposta = await this.api.post(`/NotaFiscalSaida/Entrega`, {
            codigoNotaFiscal
        })

        return resposta?.data
    }

    async ContasReceber(codigoNotaFiscal: number): Promise<any> {
        const resposta = await this.api.post(`/NotaFiscalSaida/ContasReceber`, {
            codigoNotaFiscal
        })

        return resposta?.data
    }

    async Expedicao(codigoNotaFiscal: number): Promise<any> {
        const resposta = await this.api.post(`/NotaFiscalSaida/Expedicao`, {
            codigoNotaFiscal
        })

        return resposta?.data
    }


}
